import { render } from "./NavbarV2.vue?vue&type=template&id=1c521dea"
import script from "./NavbarV2.vue?vue&type=script&lang=js"
export * from "./NavbarV2.vue?vue&type=script&lang=js"

import "./NavbarV2.vue?vue&type=style&index=0&id=1c521dea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__